import { Component, ChangeDetectionStrategy } from '@angular/core'
import { MatProgressSpinnerModule } from '@angular/material/progress-spinner'

@Component({
    selector: 'app-loading-overlay',
    templateUrl: './loading-overlay.component.html',
    changeDetection: ChangeDetectionStrategy.OnPush,
    imports: [MatProgressSpinnerModule]
})
export class LoadingOverlayComponent {

}
